import React, { useEffect, useState } from "react";
import { apiCall, apiCallResponse } from "src/_apiConfig/apiCall";
import CommonList from "src/views/common/CommonList";
import CustomeModalPopup from "src/views/common/CustomeModalPopup";
import TableButtonClick from "src/views/common/Table/TableButtonClick";

const ModelRefundHistory = (props) => {
  const [refundStatusList, setrefundStatusList] = useState();

  useEffect(() => {
    if (props.refundopen === true) {
      ShowRefundHistory(
        props.tenderid,
        props.lotNo,
        props.refundType,
        props.transferFormUserId,
        props.transferCount
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.refundopen]);

  const ShowRefundHistory = async (
    tenderid,
    lotno,
    type,
    transferFormUserId,
    transferCount
  ) => {
    //const header = new Headers();

    let url = `LotDetails/GetRefundStatus?tenderid=${tenderid}&lotno=${lotno}&refundtype=${Number(
      type
    )}`;
    if (transferFormUserId > 0)
      url = `LotDetails/GetRefundStatusByTransferFormUserId?tenderId=${tenderid}&lotNo=${lotno}&refundType=${Number(
        type
      )}&transferFormUserId=${Number(
        transferFormUserId
      )}&transferCount=${transferCount}`;
    await apiCallResponse(url, "GET").then((res) => {
      if (res.success) setrefundStatusList(res.data);
      else setrefundStatusList([]);
    });

    // const response = await apiCallResponse(
    //   `LotDetails/GetRefundStatus?tenderid=${tenderid}&lotno=${lotno}&refundtype=${Number(
    //     type
    //   )}`,
    //   "GET",
    //   header,
    //   null
    // );

    // const jsonobj = await response.json();
    // if (response.status === 200) {
    //   console.log(jsonobj);
    //   setrefundStatusList(jsonobj);
    // }

    props.setrefundopen(true);
  };

  const DownloadRefundReceipt = async (SrNo, RefundId) => {
    console.log(" SrNo: ", SrNo);
    const header = new Headers();
    const response = await apiCall(
      //`LotDetails/DownloadRefundReceipt?lotid=${Number(lotid)}&SrNo=${SrNo}`,
      `LotDetails/DownloadRefundReceipt?SrNo=${SrNo}&RefundId=${RefundId}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response;
    if (jsonobj.status === 200) {
      jsonobj.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = SrNo + ".pdf";
        alink.click();
      });
    }
  };

  let refundScopedSlotsList = {
    download_Refund_lot_receipt: (item, index) => {
      return (
        <>
          <TableButtonClick
            buttonName={" Download Refund Receipt"}
            isDisplayAllow={
              //true
              item.refundReceiptFilePath !== "" &&
              item.refundReceiptFilePath !== null &&
              item.srno !== undefined
                ? true
                : false
            }
            onClick={() => DownloadRefundReceipt(item.srno, item.id)}
          />
        </>
      );
    },
  };

  const fieldsRefunds = [
    {
      key: "srno",
      label: "SRNO",
    },
    {
      key: "date",
      label: "Date",
    },
    {
      key: "beneficiary_bank_name",
      label: "Bank Name",
    },
    {
      key: "beneficiary_account_number",
      label: "Account Number",
    },
    {
      key: "beneficiary_bank_ifsc",
      label: "IFSC Code",
    },
    {
      key: "refund_percentage",
      label: "Lot %",
    },
    {
      key: "amount",
      label: "Amount",
    },
    {
      key: "status",
      label: "Status",
    },
    {
      key: "refundType",
      label: "Refund Type",
    },
    {
      key: "rejectionreason",
      label: "Comment/Reason",
    },
    {
      key: "download_Refund_lot_receipt",
      label: "Download Receipt",
    },
  ];

  return (
    <CustomeModalPopup
      onOpen={props.refundopen}
      onClose={props.handleRefundPopupClose}
      onCloseButton={props.handleRefundPopupClose}
      popupWith={"90%"}
      body={
        <CommonList
          items={refundStatusList}
          fields={fieldsRefunds}
          listName="Refund History"
          loading={false}
          disabledprev={true}
          disablednext={true}
          displayPaggingButton={false}
          scopedSlots={refundScopedSlotsList}
        />
      }
      isFromSubmit={false}
      btnCColstyle={{ textAlign: "right" }}
      disabledBtn={false}
      btnSubmitShow={false}
      btnCloseText={"Close"}
      btnCloseShow={true}
    />
  );
};

export default ModelRefundHistory;
